import type { ControlType, HelperLocation, SubLocationDef } from './types';
import type { LibraryTitleInputProps } from '../library-title-input.types';

export const OPTION_DEBOUNCE_MS = 700;

const productInformation = 'Product Information';
const billOfMaterials = 'Bill of Materials';
const gradingGroup = 'Grading Group';
const colourwayName = 'Colourway Name';
const colourRef = 'Colour Ref';

export const cmControlBaseLocations: HelperLocation[] = [
  {
    label: 'Product Core Information',
    name: 'Product_Core_Information',
    _id: 11,
  },
  {
    label: productInformation,
    name: 'Product_Information',
    _id: 1,
  },
  {
    label: 'Supplier Information',
    name: 'Supplier_Information',
    _id: 2,
  },
  {
    label: 'Design/Details',
    name: 'Design_Details',
    _id: 13,
  },
  {
    label: billOfMaterials,
    name: 'Bill_of_Materials',
    _id: 3,
  },
  {
    label: 'Specifications',
    name: 'Specifications',
    _id: 4,
  },
  {
    label: 'Testing',
    name: 'Testing',
    _id: 5,
  },
  {
    label: 'Care/User Document Information',
    name: 'Care/User_Document_Information',
    _id: 6,
  },
  {
    label: 'Samples',
    name: 'Samples',
    _id: 8,
  },
  {
    label: 'Completion Indicator',
    name: 'Completion_Indicator',
    _id: 14,
  },
];

export const cmControlSublocations: SubLocationDef[] = [
  {
    locationId: 1,
    subLocations: [
      {
        label: 'Sizes',
        name: 'size',
        type: 'string',
      },
      {
        label: gradingGroup,
        name: 'gradingGroup',
        type: 'string',
      },
      {
        label: 'Length',
        name: 'length',
        type: 'string',
      },
      {
        label: colourwayName,
        name: 'colourwayName',
        type: 'string',
      },
      {
        label: 'Colour Description',
        name: 'colourDesc',
        type: 'string',
      },
      {
        label: 'Colour Ref',
        name: 'colourwayRef',
        type: 'string',
      },
      {
        label: 'Colour Group',
        name: 'colourGroup',
        type: 'string',
      },
      {
        label: colourRef,
        name: 'colourRef',
        type: 'string',
      },
    ],
  },
  {
    locationId: 2,
    subLocations: [
      {
        label: 'Supplier Code',
        name: 'supplierCode',
        type: 'string',
      },
      {
        label: 'Supplier Name',
        name: 'supplierName',
        type: 'string',
      },
      {
        label: 'Supplier Address',
        name: 'supplierAddress',
        type: 'string',
      },
      {
        label: 'Factory Code',
        name: 'factoryCode',
        type: 'string',
      },
      {
        label: 'Factory Name',
        name: 'factoryName',
        type: 'string',
      },
      {
        label: 'Factory Address',
        name: 'factoryAddress',
        type: 'string',
      },
      {
        label: 'Port of Lading',
        name: 'portOfLanding',
        type: 'string',
      },
      {
        label: 'MOQ',
        name: 'MOQ',
        type: 'number',
      },
      {
        label: 'MCQ',
        name: 'MCQ',
        type: 'number',
      },
      {
        label: 'Country Code',
        name: 'countryCode',
        type: 'string',
      },
      {
        label: 'Country of Origin',
        name: 'countryOfOrigin',
        type: 'string',
      },
      {
        label: 'Document Type',
        name: 'documentType',
        type: 'string',
      },
      {
        label: 'Document Name',
        name: 'documentName',
        type: 'string',
      },
      {
        label: 'Date Added',
        name: 'dateAdded',
        type: 'string',
      },
      {
        label: 'Status',
        name: 'status',
        type: 'string',
      },
      {
        label: 'Expiry Date',
        name: 'expiryDate',
        type: 'string',
      },
      {
        label: 'Assignee',
        name: 'assignee',
        type: 'string',
      },
    ],
  },
  {
    locationId: 3,
    subLocations: [
      {
        label: 'Code',
        name: 'code',
        type: 'string',
      },
      {
        label: 'Description',
        name: 'description',
        type: 'string',
      },
      {
        label: 'Component Type',
        name: 'componentType',
        type: 'string',
      },
      {
        label: 'Component Supplier',
        name: 'componentSupplier',
        type: 'string',
      },
      {
        label: 'Size',
        name: 'size',
        type: 'string',
      },
      {
        label: 'Weight',
        name: 'weight',
        type: 'number',
      },
      {
        label: 'Quantity',
        name: 'quantity',
        type: 'number',
      },
      {
        label: 'Composition',
        name: 'composition',
        type: 'string',
      },
      {
        label: 'Placement',
        name: 'placement',
        type: 'string',
      },
      {
        label: 'Finish',
        name: 'finish',
        type: 'string',
      },
      {
        label: 'Additional Information',
        name: 'additionalInformation',
        type: 'string',
      },
      {
        label: 'Colourway',
        name: 'colourway',
        type: 'string',
      },
      {
        label: 'Colour Ref',
        name: 'colourRef',
        type: 'string',
      },
      {
        label: 'No. of Colour Supporting Doc',
        name: 'colourSupportingDoc',
        type: 'number',
      },
      {
        label: 'Colour Status',
        name: 'colourStatus',
        type: 'string',
      },
      {
        label: 'Colour Comments',
        name: 'comments',
        type: 'string',
      },
      {
        label: 'No. of Quality Supporting Doc',
        name: 'qualitySupportingDoc',
        type: 'number',
      },
      {
        label: 'Quality Status',
        name: 'qualityStatus',
        type: 'string',
      },
      {
        label: 'Quality Comments',
        name: 'qualityComments',
        type: 'string',
      },
      {
        label: 'Quality Supporting Doc Name',
        name: 'qualitySupportingDocName',
        type: 'string',
      },
      {
        label: 'Quality Supporting Doc Date Added',
        name: 'qualitySupportingDocDateAdded',
        type: 'string',
      },
      {
        label: 'Colour Supporting Doc Name',
        name: 'colourSupportingDocName',
        type: 'string',
      },
      {
        label: 'Colour Supporting Doc Date Added',
        name: 'colourSupportingDocDateAdded',
        type: 'string',
      },
    ],
  },
  {
    locationId: 4,
    subLocations: [
      {
        label: 'Specification Supporting Documents',
        name: 'specificationSupportingDocuments',
        type: 'string',
      },
      {
        label: 'Size',
        name: 'size',
        type: 'string',
      },
      {
        label: 'Weight',
        name: 'weight',
        type: 'number',
      },
      {
        label: 'Volume',
        name: 'volume',
        type: 'number',
      },
      {
        label: 'E-comm Spec',
        name: 'ecomSpec',
        type: 'number',
      },
    ],
  },
  {
    locationId: 8,
    subLocations: [
      {
        label: 'Ref',
        name: 'ref',
        type: 'string',
      },
      {
        label: 'Type',
        name: 'type',
        type: 'string',
      },
      {
        label: 'Colourway',
        name: 'colourway',
        type: 'string',
      },
      {
        label: 'Size/Size Range',
        name: 'sizeRange',
        type: 'string',
      },
      {
        label: 'Due Date',
        name: 'dueDate',
        type: 'date',
      },
      {
        label: 'Status',
        name: 'status',
        type: 'string',
      },
      {
        label: 'Mark As Complete',
        name: 'markAsComplete',
        type: 'string',
      },
      {
        label: 'Status Date First',
        name: 'statusDateFirst',
        type: 'date',
      },
      {
        label: 'Status Date Latest',
        name: 'statusDateLatest',
        type: 'date',
      },
      {
        label: 'Comments Added Date First',
        name: 'commentsAddedDateFirst',
        type: 'date',
      },
      {
        label: 'Comments Added Date Latest',
        name: 'commentsAddedDateLatest',
        type: 'date',
      },
    ],
  },
  {
    locationId: 9,
    subLocations: [
      {
        label: 'Reference',
        name: 'reference',
        type: 'string',
      },
      {
        label: 'Template',
        name: 'template',
        type: 'string',
      },
      {
        label: 'Costing Type',
        name: 'costingType',
        type: 'string',
      },
      {
        label: 'Cost Status',
        name: 'costStatus',
        type: 'string',
      },
      {
        label: 'Mode',
        name: 'mode',
        type: 'string',
      },
      {
        label: 'Landed Currency',
        name: 'landedCurrency',
        type: 'string',
      },
      {
        label: 'Incoterm',
        name: 'incoterm',
        type: 'string',
      },
      {
        label: 'Colourway',
        name: 'colourway',
        type: 'string',
      },
      {
        label: 'Size',
        name: 'size',
        type: 'string',
      },
      {
        label: 'Quantity',
        name: 'quantity',
        type: 'number',
      },
      {
        label: 'Price Per Unit Incoterm',
        name: 'pricePerUnitIncoterm',
        type: 'number',
      },
      {
        label: 'Exchange Rate',
        name: 'exchangeRate',
        type: 'number',
      },
      {
        label: 'Total (Incoterm)',
        name: 'incotermTotal',
        type: 'number',
      },
      {
        label: 'Price Per Unit (Landed)',
        name: 'pricePerUnitLanded',
        type: 'number',
      },
      {
        label: 'Total (Landed)',
        name: 'totalLanded',
        type: 'number',
      },
    ],
  },
  {
    locationId: 10,
    subLocations: [
      {
        label: 'PO Number',
        name: 'poNumber',
        type: 'string',
      },
      {
        label: 'Colourway',
        name: 'poColourway',
        type: 'string',
      },
      {
        label: 'Size',
        name: 'size',
        type: 'string',
      },
      {
        label: 'Quantity',
        name: 'quantity',
        type: 'number',
      },
      {
        label: 'Creation Date',
        name: 'creationDate',
        type: 'date',
      },
      {
        label: 'Sent Date',
        name: 'sentDate',
        type: 'date',
      },
      {
        label: 'Status',
        name: 'status',
        type: 'string',
      },
      {
        label: 'Product Approve by Date (Seal by Date)',
        name: 'productApprovebyDate',
        type: 'date',
      },
      {
        label: 'Product Approved Date (Sealed Date)',
        name: 'productApprovedDate',
        type: 'date',
      },
      {
        label: 'Handover/Cargo Ready Date',
        name: 'handoverCargoReadyDate',
        type: 'date',
      },
      {
        label: 'Actual Handover/Cargo Ready Date',
        name: 'actualHandoverCargoReadyDate',
        type: 'date',
      },
      {
        label: 'Shipment Date',
        name: 'shipmentDate',
        type: 'date',
      },
      {
        label: 'Actual Shipment Date',
        name: 'actualShipmentDate',
        type: 'date',
      },
      {
        label: 'Delivery Date',
        name: 'deliveryDate',
        type: 'date',
      },
      {
        label: 'Actual Delivery Date',
        name: 'actualDeliveryDate',
        type: 'date',
      },
      {
        label: 'Shipment Method',
        name: 'shipmentMethod',
        type: 'string',
      },
      {
        label: 'Incoterms',
        name: 'incoterms',
        type: 'string',
      },
      {
        label: 'Shipping & Handling Cost Included?',
        name: 'shippingHandlingCostIncluded',
        type: 'string',
      },
      {
        label: 'Shipping and Handling Cost',
        name: 'shippingandHandlingCost',
        type: 'number',
      },
      {
        label: 'Port of Landing',
        name: 'portofLanding',
        type: 'string',
      },
      {
        label: 'Number of Revisions',
        name: 'numberofRevisions',
        type: 'number',
      },
    ],
  },
  {
    locationId: 11,
    subLocations: [
      {
        label: 'Brand',
        name: 'brand',
        type: 'string',
      },
      {
        label: 'Product Number',
        name: 'number',
        type: 'string',
      },
      {
        label: 'Description',
        name: 'description',
        type: 'string',
      },
      {
        label: 'Season',
        name: 'season',
        type: 'string',
      },
      {
        label: 'Month',
        name: 'month',
        type: 'string',
      },
      {
        label: 'Year',
        name: 'year',
        type: 'string',
      },
      {
        label: 'Status',
        name: 'status',
        type: 'string',
      },
      {
        label: 'Product Type',
        name: 'productType',
        type: 'string',
      },
      {
        label: 'category1',
        name: 'cat1',
        type: 'string',
      },
      {
        label: 'category2',
        name: 'cat2',
        type: 'string',
      },
      {
        label: 'category3',
        name: 'cat3',
        type: 'string',
      },
      {
        label: 'category4',
        name: 'cat4',
        type: 'string',
      },
      {
        label: 'Size Range',
        name: 'sizeRange',
        type: 'string',
      },
      {
        label: 'Supplier',
        name: 'supplier',
        type: 'string',
      },
      {
        label: colourwayName,
        name: 'colourwayName',
        type: 'string',
      },
      {
        label: 'No. of Colourways',
        name: 'noOfColourways',
        type: 'number',
      },
      {
        label: 'Factory',
        name: 'factory',
        type: 'string',
      },
      {
        label: 'Country Of Origin',
        name: 'productCountryOfOrigin',
        type: 'string',
      },
      {
        label: 'Original Supplier Submission',
        name: 'originalSubmission',
        type: 'date',
      },
      {
        label: 'Original Supplier Download',
        name: 'originalDownload',
        type: 'date',
      },
      {
        label: 'Most Recent Supplier Submission',
        name: 'mostRecentSubmission',
        type: 'date',
      },
      {
        label: 'Most Recent Supplier Download',
        name: 'mostRecentDownload',
        type: 'date',
      },
      {
        label: 'Licensor',
        name: 'licensor',
        type: 'string',
      },
      {
        label: 'License',
        name: 'license',
        type: 'string',
      },
      {
        label: 'Likeness',
        name: 'likeness',
        type: 'string',
      },
      {
        label: 'Transport',
        name: 'transport',
        type: 'string',
      },
      {
        label: 'Packing Method',
        name: 'packingMethod',
        type: 'string',
      },
    ],
  },
  {
    locationId: 14,
    subLocations: [
      {
        label: 'Design/Details',
        name: 'Design_Details',
        type: '',
      },
      {
        label: billOfMaterials,
        name: 'Bill_of_Materials',
        type: '',
      },
      {
        label: 'Specifications',
        name: 'Specifications',
        type: '',
      },
      {
        label: 'Testing',
        name: 'Testing',
        type: '',
      },
      {
        label: 'Care/User Document Information',
        name: 'Care/User_Document_Information',
        type: '',
      },
      {
        label: 'Samples',
        name: 'Samples',
        type: '',
      },
    ],
  },
];

export const customModuleLocations: HelperLocation[] = [
  {
    label: 'Custom Modules',
    name: 'Custom_Modules',
    _id: 15,
  },
];

export const costingInformationAttributeList = [{ label: 'Value', name: 'valueType' }];

export const purchaseOrderAttributeList = [
  { label: 'All Items', name: 'all_item' },
  { label: 'Value', name: 'valueType' },
];

export const costingInformationOutcomeList = [
  { label: 'Date Added', name: 'date_added' },
  { label: 'Value', name: 'valueType' },
];

export const purchaseOrderOutcomeList = [{ label: 'Percentage of Confirmed', name: 'completion_percentage' }];

export const PRODUCT_CORE_LOCATION_ID = 11;

export const FIELD_LIBRARY_CONTROL_TYPES: Record<ControlType, LibraryTitleInputProps['controlType']> = {
  dropdown: 'dropdown',
  text: 'text',
  radio: 'radio',
  checkbox: 'checkbox',
  date: 'date-picker',
  comment: 'comment',
  image: 'image',
  status: 'status',
  source: 'source',
  calculation: 'calculation',
  canvas: 'canvas',
  time: 'time-picker',
};
